import { render, staticRenderFns } from "./_sitesTable.vue?vue&type=template&id=44c116ed"
import script from "./_sitesTable.vue?vue&type=script&lang=js"
export * from "./_sitesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports